import auth from '../../services/auth'
import MessageDialog from '../../components/message-dialog.vue'

export default {

  data() {
    return {
      password: undefined,
      oldPassword: undefined,
      passwordRepeat: undefined,
      errorMessage: undefined,
      loading: undefined
    }
  },
  methods: {
    doChange() {
      this.$validator.validateAll()
        .then((success) => {
          this.loading = auth.changePassword(this.oldPassword, this.password)
          .then((value) => {
            if (value)
              return MessageDialog.show({
                headerClass: 'modal-success',
                title: 'Definição de senha',
                message: 'Sua senha foi alterada com sucesso!',
                type: 'OK'
              }).then(() => {
                this.$router.push({name: 'plans'});
              })

          }).catch((error) => {
              this.errorMessage = error.data && error.data.status && error.data.status.message || "Erro do servidor.";
          });
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/auth/password-change.js